<div class="agpr-briefingGlobalCustomization">
    @if(isCanvas) {
        <div class="agpr-briefingGlobalCustomization-colorLabel">
            {{ 'Briefing.onlineBriefing.settings.design.accentColor' | localize}}
        </div>
        <div class="agpr-briefingGlobalCustomization-colorPicker">
            <agpr-color-picker-field
                [config]="{
                    showRecentColors: true
                }"
                [value]="currentBriefing.generalStyles.accentColor"
                (changes)="currentBriefing.generalStyles.accentColor = $event; accentColorChanged()"
            ></agpr-color-picker-field>
        </div>
    }
    <agpr-panel header="Briefings.global.customizations.heading.briefingStyles">
        <agpr-image-style-field
            [id]="id + '_image'"
            [field]="imageField"
            [value]="currentBriefing.generalStyles.image"
            [isCanvas]="isCanvas"
            (changes)="styleChange($event, briefingBlockTypeEnum.IMAGE)"
        ></agpr-image-style-field>
        <agpr-briefing-title-style-field
            [id]="id + '.title'"
            [value]="currentBriefing.generalStyles.title"
            [field]="titleField"
            (changes)="styleChange($event, briefingBlockTypeEnum.TITLE)"
        ></agpr-briefing-title-style-field>
        <agpr-briefing-date-style-field
            [id]="id + '_dateStyle'"
            [field]="dateStyleField"
            [deliveryMethod]="currentBriefing.deliveryMethod"
            [value]="currentBriefing.generalStyles.date"
            (changes)="styleChange($event, briefingBlockTypeEnum.DATE)"
        >
        </agpr-briefing-date-style-field>
        <agpr-briefing-text-style-field
            [id]="id + '_body'"
            [field]="textField"
            [value]="currentBriefing.generalStyles.text"
            (changes)="styleChange($event, briefingBlockTypeEnum.TEXT)"
        ></agpr-briefing-text-style-field>
        <agpr-links-style-field
            [id]="id + '_link'"
            [field]="linkField"
            [value]="currentBriefing.generalStyles.link"
            [textPrimaryLabel]="true"
            (changes)="styleChange($event, briefingBlockTypeEnum.LINK)"
        ></agpr-links-style-field>
        <agpr-briefing-text-style-field
            [id]="id + '_tableOfContent'"
            [field]="tableOfContentField"
            [value]="currentBriefing.generalStyles.tableOfContent"
            (changes)="styleChange($event, briefingBlockTypeEnum.TABLE_OF_CONTENT)"
        ></agpr-briefing-text-style-field>
        <agpr-divider-style-field
            [id]="id + '.divider'"
            [field]="dividerField"
            [value]="currentBriefing.generalStyles.divider"
            (changes)="styleChange($event, briefingBlockTypeEnum.DIVIDER)"
        ></agpr-divider-style-field>
        <agpr-mention-customization-field
            [id]="id + '_mention'"
            [value]="currentBriefing.generalStyles.mention"
            [field]="mentionStyleField"
            [isCanvas]="isCanvas"
            (changes)="styleChange($event, briefingBlockTypeEnum.CURATED_MENTION_LIST)"
        ></agpr-mention-customization-field>
        @if (currentBriefing) {
            <agpr-layout-style-field
                class="agpr-briefingGlobalCustomization-oneColumnLayout"
                [id]="id + '_oneColumnLayout'"
                [field]="oneColumnLayoutField"
                [isCanvas]="isCanvas"
                [value]="currentBriefing.generalStyles.oneColumnLayout"
                [textPrimaryLabel]="true"
                (changes)="styleChange($event, briefingBlockTypeEnum.ONE_COLUMN_LAYOUT)"
            ></agpr-layout-style-field>
            <agpr-layout-style-field
                [id]="id + '_twoColumnLayout'"
                [field]="twoColumnLayoutField"
                [isCanvas]="isCanvas"
                [value]="currentBriefing.generalStyles.twoColumnLayout"
                [textPrimaryLabel]="true"
                (changes)="styleChange($event, briefingBlockTypeEnum.TWO_COLUMN_LAYOUT)"
            ></agpr-layout-style-field>
            <agpr-layout-style-field
                [id]="id + '_threeColumnLayout'"
                [field]="threeColumnLayoutField"
                [isCanvas]="isCanvas"
                [value]="currentBriefing.generalStyles.threeColumnLayout"
                [textPrimaryLabel]="true"
                (changes)="styleChange($event, briefingBlockTypeEnum.THREE_COLUMN_LAYOUT)"
            ></agpr-layout-style-field>
        }

        @if(hasCoverageInsightsEnabled) {
            <agpr-briefing-text-style-field
                [id]="id + '_analysis'"
                [field]="analysisField"
                [value]="currentBriefing.generalStyles.analysis"
                [blockPaddingLabelSemibold]="true"
                (changes)="styleChange($event, briefingBlockTypeEnum.ANALYSIS)"
            ></agpr-briefing-text-style-field>
        }
        <agpr-image-style-field
            [id]="id + '_chart'"
            [field]="chartField"
            [value]="currentBriefing.generalStyles.chart"
            [isCanvas]="isCanvas"
            (changes)="styleChange($event, briefingBlockTypeEnum.CHART)"
        ></agpr-image-style-field>

        @if(hasCoverageInsightsEnabled) {
            <agpr-curator-style-field
                [id]="id + '_curator'"
                [field]="curatorField"
                [value]="currentBriefing.generalStyles.coverageCurator"
                (changes)="styleChange($event, briefingBlockTypeEnum.COVERAGE_CURATOR)"
            ></agpr-curator-style-field>
        }
    </agpr-panel>
</div>
